import React, { Component } from 'react';
import { RichUtils } from 'draft-js';
import { Button } from '@betareader/design-system';
import ReactionsComponent from './reactionsComponent';

export class ReactionsButtons extends Component {
  onMouseDown = (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <ReactionsComponent {...this.props} />
    );
  }
}

export class BoldButton extends Component {
  onClick = (event) => {
    event.preventDefault();
    const newEditorState = RichUtils.toggleInlineStyle(this.props.getEditorState(), 'BOLD');
    this.props.setEditorState(newEditorState);
  }

  onMouseDown = event => event.preventDefault();

  render() {
    return (
      <Button
        variant='secondary'
        size='small'
        aria-label='Bold'
        onMouseDown={this.onMouseDown}
        onClick={this.onClick}
      ><strong>B</strong></Button>
    );
  }
}

export class UnderlineButton extends Component {
  onClick = (event) => {
    event.preventDefault();
    const newEditorState = RichUtils.toggleInlineStyle(this.props.getEditorState(), 'UNDERLINE');
    this.props.setEditorState(newEditorState);
  }

  onMouseDown = event => event.preventDefault();

  render() {
    return (
      <Button
        variant='secondary'
        size='small'
        aria-label='Underline'
        onMouseDown={this.onMouseDown}
        onClick={this.onClick}
      ><u>U</u></Button>)
  }
}

export class ItalicButton extends Component {
  onClick = (event) => {
    event.preventDefault();
    const newEditorState = RichUtils.toggleInlineStyle(this.props.getEditorState(), 'ITALIC');
    this.props.setEditorState(newEditorState);
  }

  onMouseDown = (event) => {
    event.preventDefault();
  }

  render() {
    return (
      <Button
        variant='secondary'
        size='small'
        aria-label='Italic'
        onMouseDown={this.onMouseDown}
        onClick={this.onClick}
      ><em>I</em></Button>
    );
  }
}

export class HeaderTwoButton extends Component {
  onClick = (event) => {
    event.preventDefault();
    const newEditorState = RichUtils.toggleBlockType(this.props.getEditorState(), 'header-two');
    this.props.setEditorState(newEditorState);
  }

  onMouseDown = event => event.preventDefault();

  render() {
    return (
      <Button variant='secondary' size='small' aria-label='Heading 2'
        onClick={this.onClick} onMouseDown={this.onMouseDown}>
        <span>H<sub>2</sub></span>
      </Button>
    );
  }
}

export class HeaderThreeButton extends Component {
  onClick = (event) => {
    event.preventDefault();
    const newEditorState = RichUtils.toggleBlockType(this.props.getEditorState(), 'header-three');
    this.props.setEditorState(newEditorState);
  }

  onMouseDown = event => event.preventDefault();

  render() {
    return (
      <Button variant='secondary' size='small' aria-label='Heading 3'
        onClick={this.onClick} onMouseDown={this.onMouseDown}>
        <span>H<sub>3</sub></span>
      </Button>
    );
  }
}

export class SplitChapterButton extends Component {
  onMouseDown = event => event.preventDefault()

  onClick = () =>
    this.props.onSplit();

  render() {
    return (
      <Button variant='secondary' size='small' aria-label='Split chapter'
        onClick={this.onClick} onMouseDown={this.onMouseDown}>
        <span aria-hidden='true'>✂</span>
      </Button>
    );
  }
}
